
import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import BackToTop from "@/components/ui/BackToTop";
import { ScrollText, UserCheck, AlertCircle } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";

const TermsOfService = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1 pt-20">
        <div className="container mx-auto px-4 py-12 max-w-4xl">
          <div className="text-center mb-12">
            <h1 className="text-4xl font-bold text-nation-blue mb-4">Terms of Service</h1>
            <p className="text-gray-600">
              Last updated: {new Date().toLocaleDateString()}
            </p>
          </div>
          
          <div className="grid gap-8">
            <Card className="border-l-4 border-l-nation-teal shadow-md">
              <CardContent className="p-6">
                <div className="flex items-start gap-4">
                  <ScrollText className="w-6 h-6 text-nation-teal flex-shrink-0 mt-1" />
                  <div>
                    <h2 className="text-2xl font-semibold text-nation-blue mb-4">1. Acceptance of Terms</h2>
                    <p className="text-gray-700 leading-relaxed">
                      By accessing and using NationCard™, you accept and agree to be bound by these Terms of Service.
                      If you do not agree to these terms, please do not use our service.
                    </p>
                  </div>
                </div>
              </CardContent>
            </Card>

            <Card className="border-l-4 border-l-nation-teal shadow-md">
              <CardContent className="p-6">
                <div className="flex items-start gap-4">
                  <UserCheck className="w-6 h-6 text-nation-teal flex-shrink-0 mt-1" />
                  <div>
                    <h2 className="text-2xl font-semibold text-nation-blue mb-4">2. Use License</h2>
                    <p className="text-gray-700 leading-relaxed">
                      NationCard™ grants you a limited, non-exclusive, non-transferable, revocable license to access
                      and use our service for personal, non-commercial purposes.
                    </p>
                  </div>
                </div>
              </CardContent>
            </Card>

            <Card className="border-l-4 border-l-nation-teal shadow-md">
              <CardContent className="p-6">
                <div className="flex items-start gap-4">
                  <AlertCircle className="w-6 h-6 text-nation-teal flex-shrink-0 mt-1" />
                  <div>
                    <h2 className="text-2xl font-semibold text-nation-blue mb-4">3. User Account</h2>
                    <p className="text-gray-700 leading-relaxed">
                      To access certain features of our service, you may be required to create an account. You are
                      responsible for maintaining the confidentiality of your account information.
                    </p>
                  </div>
                </div>
              </CardContent>
            </Card>
          </div>
        </div>
      </main>
      <Footer />
      <BackToTop />
    </div>
  );
};

export default TermsOfService;
